import {connect} from "react-redux";
import {StoreState} from "../../../app/models/states/AppStates";
import {
    ACTION_APP__CLEAR_LAST_STATE,
    ACTION_APP__GOTO_OVERVIEW,
    ACTION_APP__READY,
    ACTION_APP__START,
    ACTION_OVERVIEW__SET_DATA
} from "../../../app/actions/Actions";
import {LoadingScreen} from "./LoadingScreen";

const mapStateToProps = (state: StoreState) =>
{
    return {
        locale: state.appState.locale,
        appConfig: state.appState.appConfig,
    };
};

const mapDispatchToProps = (dispatch) =>
{
    return {
        setOverviewData: (data: any[]) => dispatch(ACTION_OVERVIEW__SET_DATA({data})),

        applicationStart: (content: any) => dispatch(ACTION_APP__START({content})),
        applicationReady: () =>
        {
            dispatch(ACTION_APP__READY({}));
        },
        openNextScreen:() => {
            dispatch(ACTION_APP__GOTO_OVERVIEW({}));
        },
        removeCurrentScreen:() => {
            dispatch(ACTION_APP__CLEAR_LAST_STATE({}));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadingScreen);